import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {
    aggiornaCommentoKpiApi,
    aggiungiCommentoKpiApi,
    getCommentoKpiByIdApi
} from "./services/CommentiServices";
import ModificaCommentoKpiView from "./ModificaCommentoKpiView";

export default function ModificaCommentoKpiController() {
    const {idKpi, idTipoImport, idCommento} = useParams();

    const [counter, setCounter] = useState(0);
    const [commento, setCommento] = useState();
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const formikRef = useRef();

    const history = useHistory();

    async function getCommento(idCommento) {
        const response = await getCommentoKpiByIdApi(idCommento, idTipoImport);
        if (parseInt(response.data.result) !== -1 && formikRef.current) {
            let data = response.data.data;

            formikRef.current.setFieldValue("testo", data.testo);
            setCommento(data);
        }
    }

    useEffect(() => {
        if (idCommento) {
            getCommento(idCommento);
        }
        //}, [idKpi, idCommento, formikRef]);
    }, [idKpi, idTipoImport, idCommento, formikRef]); //*Sara*

    const signupSchema = Yup.object().shape({
        testo: Yup.string()
            .required(translate('Questo campo è obbligatorio'))
    });

    const afterSubmit = () => {
        setCounter(counter + 1);
    }

    async function aggiornaCommentoKpi(values) {
        const response = await aggiornaCommentoKpiApi(idCommento, values);
        if (response.data.result !== 0) {
            setModalMsg(response.data.description);
            setShow(true);
        }
        afterSubmit();
        if (response.data.result === 0) {
            history.goBack();
        }
    }

    async function aggiungiCommentoKpi(values) {
        const response = await aggiungiCommentoKpiApi(idKpi, values);
        if (response.data.result !== 0) {
            setModalMsg(response.data.description);
            setShow(true);
        }
        afterSubmit();
        if (response.data.result === 0) {
            history.goBack();
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialFormValues = {
        id_kpi: idKpi,
        id_tipo_imp_dati: idTipoImport,
        testo: ''
    }

    function onSubmitForm(values) {
        if (idCommento) {
            aggiornaCommentoKpi(values);
        } else {
            aggiungiCommentoKpi(values);
        }
    }

    return (
        <ModificaCommentoKpiView
            show={show}
            commento={commento}
            idKpi={idKpi}
            idCommento={idCommento}
            formikRef={formikRef}
            setShow={setShow}
            signupSchema={signupSchema}
            modalMsg={modalMsg}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialFormValues={initialFormValues}
            onSubmitForm={onSubmitForm}
        />
    );
}